// extracted by mini-css-extract-plugin
module.exports = {"popupBox":"Popup_popupBox__f3L6X","box":"Popup_box__SVC2Q","close":"Popup_close__3S1i3","line1":"Popup_line1__24YqT","line2":"Popup_line2__2DiOw"};